import React from 'react';
import T from '../../../localization/LocalizationKeys';
import ModelType from '../../Model/ModelType';
import Icons, { Size } from '../../Common/Icons';
import Markdown from '../../Help/Markdown';

/**
 * Shows a text or markdown in a panel
 * @param {{ data: { text?: string }}} props
 * @returns {JSX.Element}
 */
const TextPanel = ({ data }) => {
  return <Markdown markdown={data?.text} />;
};

TextPanel.info = {
  label: T.dashboard.panels.types.text,
  icon: <Icons.TextAnnotationToggle size={Size.LARGE}/>,
  help: 'panels/text'
};

TextPanel.models = [
  {
    type: ModelType.TEXTAREA,
    path: 'text',
    label: T.common.input.text.title
  }
];

export default TextPanel;
